import { render } from "./SettingView.vue?vue&type=template&id=8e236808&ts=true"
import script from "./SettingView.vue?vue&type=script&lang=ts"
export * from "./SettingView.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__